export default __webpack_public_path__ + "static/media/congo_carte_2-min.1c6d293d.png";